"use client";

import { useSyncExternalStore } from "react";

const KEY = "nexo-wishlist-v1";
type Snapshot = { ids: string[]; ready: boolean };
const initial: Snapshot = { ids: [], ready: false };
let snapshot = initial;
const listeners = new Set<() => void>();

function notify() {
  listeners.forEach((listener) => listener());
}

function read() {
  try {
    const value: unknown = JSON.parse(localStorage.getItem(KEY) || "[]");
    snapshot = {
      ids: Array.isArray(value)
        ? [...new Set(value.filter((id): id is string => typeof id === "string" && id.length <= 100))].slice(0, 100)
        : [],
      ready: true,
    };
  } catch {
    snapshot = { ids: [], ready: true };
  }
  notify();
}

function onStorage(event: StorageEvent) {
  if (event.key === KEY || event.key === null) read();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  if (!snapshot.ready) read();
  if (listeners.size === 1) window.addEventListener("storage", onStorage);
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0) window.removeEventListener("storage", onStorage);
  };
}

export function useWishlist() {
  const state = useSyncExternalStore(subscribe, () => snapshot, () => initial);
  function toggle(id: string) {
    if (!id || id.length > 100) return;
    const ids = snapshot.ids.includes(id)
      ? snapshot.ids.filter((value) => value !== id)
      : [...snapshot.ids, id].slice(0, 100);
    try { localStorage.setItem(KEY, JSON.stringify(ids)); } catch { /* Browser storage can be disabled. */ }
    snapshot = { ids, ready: true };
    notify();
  }
  return { ...state, toggle };
}
